export default __webpack_public_path__ + "static/media/Verfied Pre-sale.b6a27d99.png";